'use strict';

var $ = require('jquery');

module.exports = function (options) {
	var context = options.context;

	function init() {
		context.find('[data-binding="map-satellite-list-toggle"]').on('click', function () {
			var selectedVariation = $(this);
			context.find('[data-binding="map-satellite-list-toggle"]').each(function () {
				var currentVariation = $(this);
				if (selectedVariation.is(currentVariation)) {
					currentVariation.parent().toggleClass('closed');
				} else {
					currentVariation.parent().addClass('closed');
				}
			});
		});

		context.find('[data-binding="map-satellite-list-content"]:not(:first)').addClass('closed');
	}

	return {
		init: init
	};
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/navigation-map-listing.js
// module id = 496
// module chunks = 0